// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"WidgetPanel_widgetContainer__Ahzk6"};